module.exports = __webpack_public_path__ + "img/1440.236eeaf9.jpg";